// extracted by mini-css-extract-plugin
module.exports = {"body":"waiting_body__23uCM","loading":"waiting_loading__2DJK5","loading__dot":"waiting_loading__dot__1usZw","dot":"waiting_dot__2YbCV"};